<h1>{{pageTitle}}</h1>
<h2>A graphic redesign of the home page</h2>

<mat-accordion>
  <mat-expansion-panel
    multi="false"
    expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        MOCK VIEW
      </mat-panel-title>
      <mat-panel-description>
        Vibrant brand design and coloring; tight vertical layout
      </mat-panel-description>
    </mat-expansion-panel-header>
    <figure>
      <img
        class="mid-size"
        [src]="mockIlluminatingCoWeb" />
    </figure>
  </mat-expansion-panel>
  <mat-expansion-panel
    multi="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        MOCK VIEW
      </mat-panel-title>
      <mat-panel-description>
        Login palette opened
      </mat-panel-description>
    </mat-expansion-panel-header>
    <figure>
      <img
        class="mid-size"
        [src]="mockIlluminatingCoWebLogin" />
    </figure>
  </mat-expansion-panel>
  <mat-expansion-panel
    multi="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        MOCK VIEW
      </mat-panel-title>
      <mat-panel-description>
        Main nav link menu opened
      </mat-panel-description>
    </mat-expansion-panel-header>
    <figure>
      <img
        class="mid-size"
        [src]="mockIlluminatingCoWebNav" />
    </figure>
  </mat-expansion-panel>
  <mat-expansion-panel
    multi="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        MOCK VIEW
      </mat-panel-title>
      <mat-panel-description>
        Mobile layout
      </mat-panel-description>
    </mat-expansion-panel-header>
    <figure>
      <img
        class="small"
        [src]="mockIlluminatingCoPhone" />
    </figure>
  </mat-expansion-panel>
  <mat-expansion-panel
    multi="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        MOCK VIEW
      </mat-panel-title>
      <mat-panel-description>
        Mobile layout with menu opened
      </mat-panel-description>
    </mat-expansion-panel-header>
    <figure>
      <img
        class="small"
        [src]="mockIlluminatingCoPhoneMenu" />
    </figure>
  </mat-expansion-panel>
</mat-accordion>
